<div class='wrapperToggle o-{{typeText}}'>
  <!--  <mat-slide-toggle [(ngModel)]='value' class='o-{{typeText}}'>{{text}}</mat-slide-toggle>-->

  <meSvg [svgName]='value ? (isBlue ? "toggle_true2&36":"toggle_true&36") : "toggle_false&36"'
         (emit)='disabled ? null : value=!value'
         [disabled]='disabled'></meSvg>

  <span class='o-{{typeText}}'>{{text}}</span>
</div>
